import { connect } from 'react-redux'
import Login from '../../components/authentication/Login'
import { userAuthorization } from '../../state/actions/auth/index'
import { IStoreState, IUserAuthorizationFormData } from '../../types/index'

export function mapStateToProps(state: IStoreState) {
  return {
    isFetching: state.authorization.isFetching,
    error: state.authorization.error,
    isLogged: state.authorization.isLogged,
    type: state.authorization.type
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    userAuthorization: (data: IUserAuthorizationFormData, { setSubmitting }: any) =>
      dispatch(userAuthorization(data, { setSubmitting }))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)



// WEBPACK FOOTER //
// ./src/containers/auth/Auth.ts